import type { NextPage } from 'next';
import Break from 'componentsUnits/break';
import ComponentHeader from 'componentsUnits/componentHeader';
import { Size } from 'types/size';
import { isArraysHaveCommonStrings } from 'helpers/checker';
import { joinClassnames } from 'helpers/classNames';
import styles from '../../styles/event/EventSC.module.scss';
import { Activity } from 'types/user';
import EventComponent from './eventComponent';
import Subtitle from 'componentsUnits/subtitle';
import { EntryDateIndex } from 'reducers/postReducer';
import { Event } from 'types/event';
import { Type } from 'types/type';
import { useAppSelector } from 'reducers/storeHooks';
import { isDev } from 'app/general';

interface Props {
  entryDateIndex?: EntryDateIndex[];
  activeInterests?: string[];
  title: string;
  showAll?: boolean;
  column?: boolean;
  showorganiser?: boolean;
  activity?: Activity;
  noEntriesText?: string;
  entries?: Event[];
  forceDate?: number;
}

const EventsScrollComponent: NextPage<Props> = (props: Props) => {
  const events = useAppSelector((state) => state.eventReducer.events);

  const className = joinClassnames([
    styles.component_list_wrapper,
    props.column && styles.column,
  ]);

  const renderHeader = () => {
    if (props.title &&
      ((props.entries && props.entries.length > 0)) || (props.entryDateIndex && props.entryDateIndex.length > 0)) {
      return (
        <ComponentHeader
          title={props.title}
          buttonText=""
          buttonOnClick={() => isDev && console.log('clicked')}
        />
      );
    }
    return null;
  };

  const renderEvents = () => {
    const elements: JSX.Element[] = [];
    const dateIndex = props.entryDateIndex;

    if (dateIndex) {
      dateIndex.forEach((entry, i) => {
        const event = events.get(entry.entryId);

        if (!event) return;

        const shouldShowEvent = props.showAll || isArraysHaveCommonStrings(
          props.activeInterests ?? [],
          event.interests ?? []
        );

        if (shouldShowEvent) {
          elements.push(
            <div key={i}>
              <EventComponent
                showorganiser={props.showorganiser}
                activity={props.activity}
                entryId={entry.entryId}
                event={event}
                showExcerpt={props.showAll}
                forceDate={props.forceDate}
                hideImageDate
              />
              {i < (dateIndex.length - 1) && <Break />}
            </div>
          );
        }
      });
    } else if (props.entries) {
      props.entries.forEach((event, i) => {
        elements.push(
          <div key={i}>
            <EventComponent
              event={event}
              showExcerpt
              entryId={event.id}
            />
            <Break />
          </div>
        );
      });
    }

    return elements;
  };

  return (
    <div className={styles.container}>
      {renderHeader()}
      <div className={className}>
        {(!props.entryDateIndex || props.entryDateIndex.length === 0) && props.noEntriesText && (
          <Subtitle text={props.noEntriesText} type={Type.t1} size={Size.xSmall} />
        )}
        {renderEvents()}
      </div>
    </div>
  );
};

export default EventsScrollComponent;
